export default function Index() {
    return (
        <div><p>Error page</p></div>
    );
}